import {document, params, params_documents, product} from './state';
import moment from 'moment';
import {getApiDomain, resolveImageUrl} from '../../../util/domains';
import { validationCalculateTaxes } from '../../../util/taxes';
import {isDocumentNature} from "../../utils/utils";

/**
 * Establecer un valor para la variable models.
 */
export function setModels(state, models) {
    state.models = models;
}

/**
 * Establecer un valor para la variable all_models.
 */
export function setAllModels(state, all_models) {
    state.all_models = all_models;
}

/**
 * Establecer un valor para la variable voucher_type.
 */
export function setVoucherType(state, voucher_type) {
    state.voucher_type = voucher_type;
}

export function setSellersEmployeesPointOfSale(state, data) {
    state.sellersEmployeesPointOfSale = data;
}

/**
 * Establecer un valor para la variable model.
 */
export function setModel(state, model) {
    state.model = model;

    if (model.show_availability){
        state.key_inventory = 'available'
    }else{
        state.key_inventory = 'stock'
    }
}

/**
 * Establecer un valor para la variable contact.
 */
export function setContact(state, contact) {
    state.contact = contact;
    state.contact.email = contact.email_electronic_invoice ? contact.email_electronic_invoice : contact.email;
}

/**
 * Establecer un valor para la variable price_list.
 */
export function setPriceList(state, price_list) {
    state.price_list = price_list;
}

/**
 * Establecer un valor para la variable seller.
 */
export function setSeller(state, seller) {
    state.seller = seller;
}

/**
 * Establecer el valor por defecto de la variable document.
 */
export function resetDocument(state) {
    state.document = document();
    state.selected_warehouse_id = null;
    state.selected_branchoffice_id = null;
}

/**
 * Establecer el valor por defecto de la variable params.
 */
export function resetParams(state) {
    state.params = params();
}

/**
 * Establecer un valor para la variable products.
 */
export function setProducts(state, products) {

    products.map((p, i) => {
        p.selected = i === 0;
    });

    state.products = products;
}

/**
 * Establecer un valor para el atributo price_list_id de la variable params.
 */
export function setPriceListIdParams(state, price_list_id) {
    state.params.price_list_id = price_list_id;
}

/**
 * Establecer un valor para la variable lines.
 */
export function setLines(state, lines) {
    state.lines = lines;
}

export function setSubLines(state, lines) {
    state.subLines = lines;
}

/**
 * Establecer un valor para la variable brands.
 */
export function setBrands(state, brands) {
    state.brands = brands;
}

/**
 * Establecer un valor para la variable preloader.
 */
export function setPreloader(state, preloader) {
    state.preloader = preloader;
}

/**
 * Establecer un valor para la variable document.
 */
export function setDocument(state, document) {

    let is_ventas = false;

    let subscriber = localStorage.getItem('subscriber');

    if (subscriber) {
        subscriber = JSON.parse(subscriber);
        is_ventas = subscriber.identification === '800198348'
    }

    if (!document.documents_products) {
        document.documents_products = [];
    } else if (!!document.documents_products.length) {
        document.documents_products.map(dp => {
            if (state.finished_document && !state.only_view && state.set_back_order) {
                dp.quantity = dp.backorder_quantity;
            }

            const inventory = dp.product.inventory;

            dp.updated_at_as_time = moment(dp.created_at).toDate().getTime();
            /*if (dp.manage_inventory && (!inventory || !inventory[0] || +inventory[0][state.key_inventory] === 0 || inventory[0][state.key_inventory] < dp.quantity)) {
                dp.updated_at_as_time = moment().add(1, 'hour').toDate().getTime();
            } else {
                dp.updated_at_as_time = moment(dp.updated_at).toDate().getTime();
            }*/

            dp.unit_value_iva = dp.total_value_iva / dp.quantity;
            dp.exist_equivalent_products = dp.product.exist_equivalent_products;
            dp.state = dp.product.state;
        });

        if (!state.editing) {
            //&& !is_ventas
            //document.documents_products.sort((a, b) => b.updated_at_as_time - a.updated_at_as_time);
            document.documents_products.sort((a, b) => a.updated_at_as_time - b.updated_at_as_time);
        }

    }

    state.document = document;
}

/**
 * Asigna valores por defecto a branchoffice_id y branchoffice_warehouse_id de document
 * Los valores por defecto son los que se encuentran en el localStorage
 */
export function setDefaultBranchOfficeAndBranchOfficeWarehouse(state) {
    let branchoffice_id = localStorage.getItem('selected_branchoffice');
    let branchoffice_warehouse_id = localStorage.getItem('selected_branchoffice_warehouse');

    state.document.branchoffice_id = Number(branchoffice_id);
    state.document.branchoffice_warehouse_id = Number(branchoffice_warehouse_id);
}

/**
 * Establecer un valor para el atributo operationType_id de la variable document.
 */
export function setOperationTypeIdDocument(state, operationType_id) {
    state.document.operationType_id = operationType_id;
}


/**
 * Establecer un valor para el atributo model_id de la variable document.
 */
export function setModelIdDocument(state, model_id) {
    state.document.model_id = model_id;
}

/**
 * Establecer un valor para la variable toggle_table.
 */
export function toggleTable(state) {
    state.toggle_table = !state.toggle_table;
}

/**
 * Establecer un valor para la variable toggle_table.
 */
export function setToggleTable(state, toggle_table) {
    state.toggle_table = toggle_table;
}

/**
 * Establecer un valor para la variable active.
 */
export function changeActiveProduct(state, down) {

    if (state.toggle_table) {
        const index_product = state.products.findIndex(p => p.selected);

        if (index_product >= 0) {
            if (down && index_product < state.products.length) {
                state.products[index_product].selected = false;
                state.products[index_product + 1].selected = true;
            } else if (!down && index_product > 0) {
                state.products[index_product].selected = false;
                state.products[index_product - 1].selected = true;
            }
        }
    }
}

/**
 * Establecer un valor para la variable active.
 */
export function setActiveProduct(state, index) {
    state.products.map((p, i) => {
        p.selected = i === index;
    });
}

/**
 * Establecer un valor para la variable document_product.
 */
export function setDocumentProduct(state, product) {
    let quantity = 1;

    if (!!product.quantity) {
        quantity = product.quantity;
    }

    let document_product = state.document_product;

    document_product.price_list_id = state.price_list.id;
    document_product.unit_value_list = product.unit_value_after_taxes;
    document_product.branchoffice_warehouse_id = state.document.branchoffice_warehouse_id;
    document_product.description = product.description;
    document_product.document_product_id = null;
    document_product.quantity = quantity;
    document_product.product = product;
    document_product.original_quantity = quantity;
    document_product.model_id = state.model.id;
    document_product.seller_id = state.seller.id;
    document_product.document_id = state.document.id;
    document_product.product_id = product.id;
    document_product.contact_id = state.contact.id;
    document_product.physical_unit = true;
    document_product.unit_value_before_taxes = product.unit_value_before_taxes;
    document_product.unit_value_after_taxes = product.unit_value_after_taxes;
    document_product.total_value_iva = product.unit_value_iva * quantity;
    document_product.total_value = product.unit_value_after_taxes * quantity;
    document_product.total_value_brut = product.unit_value_before_taxes * quantity;
    document_product.operationType_id = state.document.operationType_id;
}

/**
 * Establecer un valor para el atributo show de la variable modal_save_restore.
 */
export function setShowToModalSaveRestore(state, show) {
    state.modal_save_restore.show = show;
    state.modal_save_restore.id = null;
}

/**
 * Establecer un valor para el atributo saving de la variable modal_save_restore.
 */
export function setSavingToModalSaveRestore(state, saving) {
    state.modal_save_restore.saving = saving;
}

/**
 * Establecer un valor para la variable documents.
 */
export function setDocuments(state, documents) {
    state.documents = documents;
}

/**
 * Establecer un valor para el atributo name de la variable document.
 */
export function setNameToDocument(state, name) {
    state.document.name = name;
}

/**
 * Establecer un valor para el atributo id de la variable document.
 */
export function setIdToDocument(state, id) {
    state.document.id = id;
}

/**
 * Establecer un valor para el atributo filter de la variable params.
 */
export function setFilterToParams(state, filter) {
    state.params.filter = filter;
}

/**
 * Establecer un valor para la variable mode.
 */
export function toggleModeParams(state, mode) {
    state.params.mode = mode;
}

/**
 * Establecer un valor para la variable ultra.
 */
export function toggleUltraParams(state) {
    state.params.ultra = !state.params.ultra;
}

/**
 * Establecer un valor para el atributo mode de la variable params.
 */
export function setModeToParams(state, mode) {
    state.params.mode = mode;
}

/**
 * Establecer un valor para el atributo show de la variable modal_mode.
 */
export function setShowToModalMode(state, show) {
    state.modal_mode.show = show;
}

export function setShowToModalOdvNewFeatures(state, show) {
    state.modal_odv_new_features.show = show;
}

/**
 * Establecer un valor para la variable model_form.
 */
export function setModelForm(state, model_form) {
    state.model_form = model_form;
}

/**
 * Establecer un valor para la variable url_pdf.
 */
export function setUrlPdf(state, url_pdf) {
    if (!state.url_pdf) {
        state.url_pdf = url_pdf;
    } else {
        state.url_pdf_two = url_pdf;
    }
}

/**
 * Establecer un valor para la variable url_pdf_two.
 */
export function setUrlPdfTwo(state, url_pdf_two) {
    state.url_pdf_two = url_pdf_two;
}

/**
 * Establecer el valor por defecto de la variable url_pdf.
 */
export function resetUrlPdf(state) {
    state.url_pdf = '';
    state.url_pdf_two = ''
}

/**
 * Establecer un valor para el atributo show de la variable modal_pdf.
 */
export function setShowToModalPdf(state, show) {
    state.modal_pdf.show = show;
    if (!show) {
        state.url_pdf = '';
        state.url_pdf_two = ''
    }
}

/**
 * Establecer un valor para la variable finished_document.
 */
export function setFinishedDocument(state, finished_document) {
    state.finished_document = finished_document;
}

/**
 * Establecer un valor para la variable allow_rollback.
 */
export function setAllowRollback(state, allow_rollback) {
    state.allow_rollback = allow_rollback;
}

/**
 * Establecer un valor para la variable cancel.
 */
export function setCancel(state, cancel) {
    state.cancel = cancel;
}


/**
 * Establecer un valor para el atributo pass_inventory_validation de la variable documents_products.
 */
export function setPassInventoryValidationToDocumentsProducts(state, documents_products) {

    let temp_documents_products = JSON.parse(JSON.stringify(state.document.documents_products));

    documents_products.map(dp => {
        let ssdp = temp_documents_products.find(sdp => sdp.id === dp.id);

        if (ssdp) {
            ssdp.stock = dp.stock;
            ssdp.available = dp.available;
            ssdp.pass_inventory_validation = dp.pass_inventory_validation;
        }
    });

    state.document.documents_products = temp_documents_products;
}

/**
 * Establecer un valor para la variable with_existences.
 */
export function toggleWithExistencesParams(state) {
    state.params.with_existences = !state.params.with_existences;
}

/**
 * Establecer un valor para el atributo printing_format_point_of_sale_id de la variable model.
 */
export function setPrintTemplateIdToModel(state, printing_format_point_of_sale_id) {
    state.model.printing_format_point_of_sale_id = printing_format_point_of_sale_id;
}

/**
 * Establecer un valor para la variable sellers.
 */
export function setSellers(state, sellers) {
    state.sellers = sellers;
}

/**
 * Establecer un valor para la variable reverse_mode.
 */
export function setReverseMode(state, reverse_mode) {
    state.reverse_mode = reverse_mode;
}

/**
 * Establecer un valor para la variable original_document_id.
 */
export function setOriginalDocumentId(state, original_document_id) {
    state.original_document_id = original_document_id;
}

/**
 * Establecer un valor para la variable only_view.
 */
export function setOnlyView(state, only_view) {
    state.only_view = only_view;
}

/**
 * Establecer el valor por defecto de la variable product.
 */
export function resetProduct(state) {
    state.product = product();
}

/**
 * Establecer un valor para el atributo ultra de la variable params.
 */
export function setUltraToParams(state, ultra) {
    state.params.ultra = ultra;
}

/**
 * Establecer un valor para la variable product.
 */
export function setProduct(state, new_product) {

    let product = JSON.parse(JSON.stringify(new_product))

    let quantity = 1;

    if (+product.quantity > 0) {
        quantity = +product.quantity;
    }

    let iva_value     = 0;
    let impo_value    = 0;
    let price         = +product.price;
    let price_base    = +product.price;
    let include_taxes          = product.include_taxes && product.include_taxes.trim().toUpperCase() === 'SI';
    let factor_taxes  = !state.document.warehouse || !state.document.warehouse.excluded_taxes ? 1 : 0;
    let factor_impo   = state.model.manage_nonconsumption ? 1 : 0;
    const validation_calculate_taxes = validationCalculateTaxes(state.document, null);
    const is_sale = isDocumentNature(state.document.vouchertype.document_nature.code_parameter, 'sale');
    const is_buy = isDocumentNature(state.document.vouchertype.document_nature.code_parameter, 'buy');

    let taxes_pct = 0;
    let iva_pct = 0;

    if (is_buy) {
        taxes_pct = +product.percentage_iva_buy * factor_taxes;
        iva_pct   = +product.percentage_iva_buy * factor_taxes;
    }

    if (is_sale) {
        taxes_pct = +product.percentage_sale * factor_taxes;
        iva_pct   = +product.percentage_sale * factor_taxes;
    }

    let impo_pct  = +product.percentage_consumption_tax * factor_impo;

    product.unit_value_list = product.price;
    product.percentage_iva_sale = iva_pct;

    if (!!product.value_consumption_tax) {
        impo_value = product.value_consumption_tax * quantity * factor_impo;
    } else if (!!impo_pct) {
        taxes_pct += +impo_pct;
    }

    if (!!include_taxes) {
        if (!validation_calculate_taxes) {
            price = Math.round((price / (1 + (iva_pct/100))));
            product.unit_list_value = price;
            product.unit_value_list = price_base;
        }
        product.total_value = Math.round(price * quantity);
        product.total_value_brut = Math.round((((product.total_value - impo_value) / (1 + (taxes_pct / 100))) + Number.EPSILON) * 100) / 100;;
    } else {
        let total_value_brut = price * quantity;

        iva_value = Math.round(((+total_value_brut * (+iva_pct / 100)) + Number.EPSILON) * 100) / 100;

        if (!validation_calculate_taxes) {
            iva_value = 0;
        }

        impo_value = impo_value ? impo_value : Math.round(((+total_value_brut * (+impo_pct / 100)) + Number.EPSILON) * 100) / 100;

        product.total_value_brut = total_value_brut;
        product.total_value = Math.round(total_value_brut + iva_value + impo_value);
    }

    product.total_value_iva = product.total_value - product.total_value_brut - impo_value;
    product.price = product.total_value / quantity;
    product.unit_value_before_taxes = product.total_value_brut / quantity;
    product.unit_value_after_taxes = Math.round(product.total_value / quantity);
    if (!include_taxes && !!product.update_blocking){
        product.unit_value_after_taxes = price;
    }
    product.unit_value_iva = product.total_value_iva / quantity;

    state.product = product;
}


/**
 * Establecer un valor para la variable set_back_order.
 */
export function setSetBackOrder(state, set_back_order) {
    state.set_back_order = set_back_order;
}

/**
 * Establecer un valor para el atributo show de la variable modal_detail.
 */
export function setShowToModalDetail(state, show) {
    state.modal_detail.show = show;
}

/**
 * Establecer un valor para la variable product_detail.
 */
export function setProductDetail(state, product_detail) {

    if (!!product_detail.products_attachments.length) {
        product_detail.products_attachments.map((pa, i) => {
            pa.selected = i === 0;
            pa.src   = resolveImageUrl(pa.src);
            pa.thumb = resolveImageUrl(pa.thumb);
        });
    }

    state.product_detail = product_detail;
}

/**
 * Establecer un valor para el atributo selected de la variable products_attachments.
 */
export function setSelectedToProductsAttachments(state, product_attachment) {
    state.product_detail.products_attachments.map((pa, i) => {
        pa.selected = pa.id === product_attachment.id;
    });
}

/**
 * Establecer un valor para la variable data_sheets.
 */
export function setDataSheets(state, data_sheets) {
    state.data_sheets = data_sheets;
}

/**
 * Establecer un valor para la variable editing.
 */
export function setEditing(state, editing) {
    state.editing = editing;
}

/**
 * Establecer un valor para la variable uvt_control.
 */
export function setUvtControl(state, uvt_control) {
    state.uvt_control = uvt_control;
}

/**
 * Establecer un valor para la variable printers.
 */
export function setPrinters(state, printers) {
    state.printers = printers;
}

/**
 * Establecer un valor para el atributo name de la variable selected_printer.
 */
export function setNameToSelectedPrinter(state, name) {
    state.selected_printer.name = name;
}

/**
 * Establecer un valor para la variable subscriber.
 */
export function setSubscriber(state, subscriber) {
    state.subscriber = subscriber;

    state.uvt_limit_value = +subscriber.uvt_value * +subscriber.uvt_electronic_invoice;
}

/**
 * Establecer un valor para el atributo show de la variable modal_options.
 */
export function setShowToModalOptions(state, show) {
    state.modal_options.show = show;
}

/**
 * Establecer un valor para la variable price_lists.
 */
export function setPriceLists(state, price_lists) {
    state.price_lists = price_lists;
}

/**
 * Establecer un valor para la variable prices.
 */
export function setPrices(state, prices) {
    state.prices = prices;
}

/**
 * Establecer un valor para la variable selected_document_product.
 */
export function setSelectedDocumentProduct(state, selected_document_product) {
    let is_ventas = false;
    const exist_tax_combo = selected_document_product.document_product_taxes.some(item => item.tax.code === '101');

    let subscriber = localStorage.getItem('subscriber');

    if (subscriber) {
        subscriber = JSON.parse(subscriber);
        is_ventas = subscriber.identification === '800198348'
    }

    let sdp = selected_document_product;

    const is_combo = sdp.product.combo;

    let price_list = state.price_lists.find(pl => pl.code_parameter === '001');

    if (state.params.price_list_id) {
        price_list = state.price_lists.find(pl => pl.id === state.params.price_list_id);
    }

    if (state.model.price_list_margin_vta_id && state.params.price_list_id !== sdp.price_list_id) {
        price_list = state.price_lists.find(pl => pl.id === sdp.price_list_id)
    }

    let iva_value = 0;
    let iva_five_combo_value = 0;
    let impo_value = 0;
    let quantity = sdp.quantity;
    let from_total_value = sdp.from_total_value;
    let taxes_pct = 0;
    let iva_pct = 0;
    const is_sale = isDocumentNature(state.document.vouchertype.document_nature.code_parameter, 'sale');
    const is_buy = isDocumentNature(state.document.vouchertype.document_nature.code_parameter, 'buy');

    let factor_taxes = !state.document.warehouse || !state.document.warehouse.excluded_taxes ? 1 : 0;
    let factor_impo = state.model.manage_nonconsumption ? 1 : 0;
    let include_taxes = price_list && price_list.alphanum_data_second ? price_list.alphanum_data_second.trim().toUpperCase() === 'SI' : false;

    if (!include_taxes &&  selected_document_product.margin_price_vta != 0 && state.model.calculate_taxes) {
        include_taxes = true;
    }

    let impo_pct = +sdp.product.percentage_consumption_tax * factor_impo;

    let iva_five_combo_pct = 0;
    if (is_ventas && is_combo && exist_tax_combo) {
        taxes_pct = +sdp.product.percentage_iva_buy * factor_taxes;
        iva_pct = +sdp.product.percentage_iva_buy * factor_taxes;

        taxes_pct += +sdp.product.percentage_iva_sale * factor_taxes;
        iva_five_combo_pct = +sdp.product.percentage_iva_sale * factor_taxes;
    } else {
        if (is_buy) {
            taxes_pct = +sdp.product.percentage_iva_buy * factor_taxes;
            iva_pct = +sdp.product.percentage_iva_buy * factor_taxes;
        }

        if (is_sale) {
            taxes_pct = +sdp.product.percentage_iva_sale * factor_taxes;
            iva_pct = +sdp.product.percentage_iva_sale * factor_taxes;
        }
    }

    if (include_taxes && from_total_value) {
        let unit_value = sdp.total_value / quantity;
        sdp.unit_value_list = unit_value;
        sdp.unit_list_value = unit_value;
    }

    if (!include_taxes && from_total_value) {
        let unit_total = sdp.total_value / quantity; // = 20000
        let unit_value = unit_total / (1 + iva_pct / 100);
        sdp.unit_value_list = unit_value;
        sdp.unit_list_value = unit_value;
    }


    let price = sdp.unit_value_list;
    let price_base= +sdp.unit_value_list;
    //console.log(price_base);
    let discount_pct = +sdp.percentage_discount;
    let discount_value = Number(sdp.discount_value) || 0;

    if (!!sdp.product.value_consumption_tax) {
        impo_value = sdp.product.value_consumption_tax * sdp.quantity;
    } else if (!!impo_pct) {
        taxes_pct += +impo_pct;
    }

    const validation_calculate_taxes = validationCalculateTaxes(state.document, null);

    if (include_taxes) {
        if (!validation_calculate_taxes) {
            price = Math.round((price / (1 + (iva_pct/100))));
            sdp.unit_value_list = price_base;
        }
        sdp.total_value = Math.round(price * quantity * (1 - discount_pct / 100) - discount_value);
        sdp.total_value_brut = Math.round((((sdp.total_value - impo_value) / (1 + (taxes_pct / 100))) + Number.EPSILON) * 100) / 100;
    } else {
        let total_value_brut = price * quantity * (1 - discount_pct / 100) - discount_value;

        iva_value = Math.round(((+total_value_brut * (+iva_pct / 100)) + Number.EPSILON) * 100) / 100;
        iva_five_combo_value = Math.round(((+total_value_brut * (+iva_five_combo_pct / 100)) + Number.EPSILON) * 100) / 100;

        impo_value = impo_value ? impo_value : Math.round(((+total_value_brut * (+impo_pct / 100)) + Number.EPSILON) * 100) / 100;

        if (!validation_calculate_taxes) {
            iva_value = 0;
        }

        sdp.total_value_brut = total_value_brut;
        sdp.total_value = Math.round(total_value_brut + iva_value + impo_value + iva_five_combo_value);
    }

    sdp.backorder_quantity = null;
    sdp.sdp_id = sdp.id;
    sdp.model_id = state.model.id;
    sdp.total_value_iva = sdp.total_value - sdp.total_value_brut - impo_value;
    sdp.price = sdp.total_value / quantity;
    sdp.unit_value_before_taxes = sdp.total_value_brut / quantity;
    sdp.unit_value_after_taxes = Math.round(sdp.total_value / quantity);
    sdp.unit_value_iva = sdp.total_value_iva / quantity;

    state.selected_document_product = sdp;
}

/**
 * Establecer un valor para el atributo unit_value_list de la variable selected_document_product.
 */
export function setUnitValueListToSelectedDocumentProduct(state, unit_value_list) {
    state.selected_document_product.unit_value_list = unit_value_list;
}

/**
 * Establecer un valor para el atributo unit_list_value de la variable selected_document_product.
 */
export function setUnitListValueToSelectedDocumentProduct(state, {unit_list_value, user_id}) {
    state.selected_document_product.unit_list_value = unit_list_value;
    //state.selected_document_product.unit_value_list = unit_list_value;
    state.selected_document_product.authorize_change_price_user_id = user_id;
}

/**
 * Establecer un valor para la variable types.
 */
export function setTypes(state, types) {
    state.types = types;

    if (state.document.vouchertype.document_nature
        && state.document.vouchertype.document_nature.code_parameter === '20') {
        const type = types.find(t => t.code_parameter === '2');

        if (type) {
            state.params.type_id = type.id;
        }
    }
}

/**
 * Establecer un valor para la variable contact_subscriber.
 */
export function setContactSubscriber(state, contact_subscriber) {
    state.contact_subscriber = contact_subscriber;
}

/**
 * Establecer el valor por defecto de la variable params_documents.
 */
export function resetParamsDocuments(state) {
    state.params_documents = params_documents();
}

/**
 * Establecer un valor para la variable documents_with_dispatch_request.
 */
export function setDocumentsWithDispatchRequest(state, documents_with_dispatch_request) {
    state.documents_with_dispatch_request = documents_with_dispatch_request;
}

/**
 * Establecer un valor para el atributo with_existences de la variable params.
 */
export function setWithExistencesToParams(state, with_existences) {
    state.params.with_existences = with_existences;
}

/**
 * Establecer un valor para la variable documents_by_thread.
 */
export function setDocumentsByThread(state, documents_by_thread) {
    state.documents_by_thread = documents_by_thread;
}

/**
 * Establecer un valor para la variable edit_mode.
 */
export function setEditMode(state, edit_mode) {
    state.edit_mode = edit_mode;
}

/**
 * Establecer un valor para la variable balance_payable.
 */
export function setBalancePayable(state, balance_payable) {
    if (balance_payable && balance_payable[0]){
        state.balance_payable = balance_payable[0].final_balance;
        state.defeated_balance = balance_payable[0].defeated_balance;
    }
}

/**
 * Establecer el valor por defecto de la variable balance_payable.
 */
export function resetBalancePayable(state) {
    state.balance_payable = 0;
    state.defeated_balance = 0;
}

/**
 * Establecer un valor para la variable doc_for_prods_without_avail.
 */
export function setDocForProdsWithoutAvail(state, doc_for_prods_without_avail) {
    state.doc_for_prods_without_avail = doc_for_prods_without_avail;
}

/**
 * Establecer un valor para el atributo show de la variable modal_authorization.
 */
export function setShowToModalAuthorization(state, show) {
    state.modal_authorization.show = show;
}

/**
 * Establecer un valor para la variable users.
 */
export function setUsers(state, users) {
    state.users = users;
}

/**
 * Establecer un valor para el atributo price_list_id de la variable params.
 */
export function setPriceListIdToParams(state, price_list_id) {
    state.params.price_list_id = price_list_id;
}

/**
 * Establecer un valor para la variable key_inventory.
 */
export function setKeyInventory(state, key_inventory) {
    state.key_inventory = key_inventory;
}

/**
 * Establecer un valor para el atributo general_discount de la variable document.
 */
export function setGeneralDiscountToDocument(state, general_discount) {
    state.document.general_discount = general_discount;
}

/**
 * Establecer un valor para la variable contact_default.
 */
export function setContactDefault(state, contact_default) {
    state.contact_default = contact_default;
}

/**
 *
 */
export function resetUserAuthentication (state) {
    state.params.user_id_authorizes = null;
    state.params.authorize_discount_user_id = null;
}
// Establece valor para la variable user_id_authorize_wallet_payments_methods
export function setUserIdAuthorizeWalletPaymentsMethods (state, user_id) {
    state.user_id_authorize_wallet_payments_methods = user_id;
}

export function setEquivalentsProducts (state, equivalents_products) {
    state.equivalents_products = equivalents_products;
}

export function resetFilters(state) {
    state.params = {
        ...state.params,
        brand_id: null,
        line_id: null,
        type_id: null,
        with_existences: false,
        
        vehicle_brand_id: null,
        vehicle_model_id: null,
        vehicle_year_id: null,
        vehicle_engine_displacement_id: null,
        vehicle_transmission_id: null
    }
}

export function setExistWarehouseData (state, data) {
    state.exist_warehouse_data = data;
}

export function setSelectedOptionDetailProduct (state, data) {
    state.selected_option_detail_product = data;
}

export function setBranchOfficeWarehouse (state, data) {
    state.branch_office_warehouse = data;
}

export function setSelectedWarehouseId (state, data) {
    state.selected_warehouse_id = data;
}
export function setOrdServiceStates(state, data) {
    state.ordServiceStates = data;
}

export function setIsMobile(state, data) {
    state.isMobile = data;
}

export function setServiceOrderAuthorize(state, data) {
    state.serviceOrderAuthorize = data;
}

export function setContactsVehicle (state, contacts_vehicle) {
    state.contacts_vehicle = contacts_vehicle;
}

/**
 * Establecer un valor para el atributo show de la variable modal_price.
 */
export function setShowToModalPrice(state, show) {
    state.modal_price.show = show;
}

/**
 * Establecer un valor para el codigo del producto
 */
export function setCodeProduct (state, code) {
    state.product.code = code;
}

export function setLoadingButtonQuantityMobile (state, loading_button_quantity_mobile) {
    state.loading_button_quantity_mobile = loading_button_quantity_mobile
}

/**
 * Establecer un valor para el dato edit_all_fields
 */
export function setDisabledEditFields (state, disabled_edit_fields) {
    state.disabled_edit_fields = !!disabled_edit_fields;
}

/**
 * Establecer un valor para branch_office
 */
export function setBranchOffice(state, data) {
    state.branch_office = data;
}

export function setSelectedBranchOfficeId (state, data) {
    state.selected_branchoffice_id = data;
}

export function setSelectedBranchOffice(state, selected_branchoffice) {
    let found_branchoffice = JSON.parse(localStorage.branchoffices).find(
        b => b.id == selected_branchoffice
    );

    if (found_branchoffice === undefined) {
        found_branchoffice = state.branchoffices.find(b => b.main);
    }

    let branchoffice_id = found_branchoffice.id;

    state.selected_branchoffice = branchoffice_id;
    localStorage.setItem("selected_branchoffice", branchoffice_id);
}

export function setCostCenter (state, cost_center) {
    state.cost_center = cost_center;
}


// WEBPACK FOOTER //
// ./src/point_of_sale/modules/point_of_sale/mutations.js